import * as _ from 'lodash';
import { IFieldValidator } from 'src/app/interfaces/field-settings.interface';
import { IFieldValidationParams } from 'src/app/interfaces/zc-validation-result.interface';

export class RangeFieldValidator implements IFieldValidator {
    private minValue: number;
    private maxValue?: number;

    propertyName: string = null;

    constructor(min: number, max?: number) {
        this.minValue = min;
        if (max) {
            this.maxValue = max;
        }
    }

    validate(params: IFieldValidationParams): string {
        if (this.isValid(params)) {
            return null;
        }

        return !this.maxValue && this.maxValue !== 0
            ? `Value can't be less than ${this.minValue}`
            : `Value must be between ${this.minValue} and ${this.maxValue}`;
    }

    private isValid(params: IFieldValidationParams): boolean {
        const value = _.get(params.currentModelState, this.propertyName, null);
        if (!this.maxValue && this.maxValue !== 0) {
            return value >= this.minValue;
        }
        return value >= this.minValue && value <= this.maxValue;
    }
}
